import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { BlueOxHostProvider } from '@blueox/components/host/BlueOxHostContext';

/** Passes the signed-in user into shared Blue Ox components such as the data grid. */
export default function BlueOxAuthBridge({ children }) {
  const { user } = useAuth();
  return <BlueOxHostProvider user={user}>{children}</BlueOxHostProvider>;
}
